var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUncheckAll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-1.0225115,-1.0302069)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g463",
    transform: "matrix(0.95193475,0,0,0.9565983,0.04913835,1.0863487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 3.0364472,8.8668484 H 1.0225209 V 23.009778 c 0,1.111263 0.9062663,2.020434 2.0139263,2.020434 H 17.13392 V 23.009778 H 3.0364472 Z",
    id: "path9",
    style: {
      strokeWidth: 1.00858
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.6242379,5.5747897 H 4.6103116 V 19.717716 c 0,1.111263 0.9062662,2.020433 2.0139263,2.020433 H 20.721711 V 19.717716 H 6.6242379 Z",
    id: "path358",
    style: {
      strokeWidth: 1.00858
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.220407,1.9617328 V 16.104662 H 10.122934 V 1.9617328 h 14.097473 m 0,-2.02042184 H 10.122934 c -1.1076604,0 -2.0139267,0.90918922 -2.0139267,2.02042184 V 16.104662 c 0,1.111225 0.9062663,2.020434 2.0139267,2.020434 h 14.097473 c 1.10766,0 2.013926,-0.909209 2.013926,-2.020434 V 1.9617328 c 0,-1.11123262 -0.906266,-2.02042184 -2.013926,-2.02042184 z",
    id: "path360",
    style: {
      strokeWidth: 1.00858
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckAll);
export default __webpack_public_path__ + "static/media/uncheck-all.45e7338e12980d4557762f223a63fa53.svg";
export { ForwardRef as ReactComponent };